import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

export const useListingForPagination = <T>(
    items: T[],
    isLoadMore = false,
): [T[], boolean, Dispatch<SetStateAction<boolean>>] => {
    const [itemList, setItemList] = useState(items);
    const itemsRef = useRef(items);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isLoadMore) {
            if (JSON.stringify(itemsRef.current) !== JSON.stringify(items)) {
                setItemList((prevItems) => [...prevItems, ...items]);
                setTimeout(() => setIsLoading(false), 500);
            }
        } else {
            setItemList(items);
            setIsLoading(false);
        }
        itemsRef.current = items;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsRef, JSON.stringify(items), isLoadMore]);

    return [itemList, isLoading, setIsLoading];
};
